module["exports"] = [
  "أحمر",
  "أخضر",
  "أزرق",
  "أصفر",
  "purple",
  "mint green",
  "teal",
  "أبيض",
  "أسود",
  "برتقالي",
  "pink",
  "بني",
  "maroon",
  "بنفسجي",
  "turquoise",
  "tan",
  "sky blue",
  "salmon",
  "plum",
  "orchid",
  "olive",
  "magenta",
  "lime",
  "ivory",
  "indigo",
  "ذهبي",
  "fuchsia",
  "cyan",
  "azure",
  "lavender",
  "فضي"
];
